// Operator-controlled aliases, never accepted from a request or an editor form.
// Example shape: { "legacy.example.com": "existing-publication-uuid" }.
// Canonical domains remain authoritative on Publication.primaryDomain.
export function publicDomain(value) {
  if (typeof value !== "string" || !/^[a-z0-9.-]+$/i.test(value)) return "";
  const domain = value.toLowerCase();
  if (domain.length > 253 || !domain.includes(".") || /^\d+(?:\.\d+){3}$/.test(domain)) return "";
  if (domain.split(".").some(label => !/^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i.test(label))) return "";
  return domain;
}

export function domainAliases(raw = process.env.PUBLICATION_DOMAIN_ALIASES || "") {
  try {
    const input = JSON.parse(raw || "{}");
    if (!input || Array.isArray(input) || typeof input !== "object") return {};
    const aliases = Object.create(null);
    for (const [host, id] of Object.entries(input)) {
      const domain = publicDomain(host);
      if (!domain || !/^[a-f0-9]{8}(?:-[a-f0-9]{4}){3}-[a-f0-9]{12}$/i.test(id)) return {};
      const bare = domain.replace(/^www\./, "");
      for (const key of [bare, `www.${bare}`]) {
        if (aliases[key] && aliases[key] !== id) return {};
        aliases[key] = id;
      }
    }
    return aliases;
  } catch { return {}; }
}

export function canonicalAliasRedirect(publication, host, pathAndQuery, aliases = domainAliases()) {
  if (publication?.status !== "LIVE" || !Object.values(aliases).includes(publication.id)) return null;
  const canonical = publicDomain(publication.primaryDomain);
  const incoming = publicDomain(host);
  if (!canonical || !incoming || incoming === canonical) return null;
  // An already configured host belonging to another publication wins resolution.
  if (aliases[incoming] !== publication.id && incoming !== `www.${canonical}`) return null;
  if (typeof pathAndQuery !== "string" || !pathAndQuery.startsWith("/") || pathAndQuery.startsWith("//") || /[\\\r\n]/.test(pathAndQuery)) return null;
  // Concatenation preserves path/query; never resolve a network-path URL.
  return `https://${canonical}${pathAndQuery}`;
}
